export default __webpack_public_path__ + "static/media/assessment-level-5.200eb415.svg";